const avtoPathesHead = {
  city: (data, p) => ({
    title: `Автосалоны грузовых автомобилей ${p.t(data.city)}. Все автодилеры по продаже грузовиков - АвтоБазар`,
    description: `Автосалоны грузовиков ${p.t(data.city)}. Лучшие предложения на грузовые автомобили от автодилеров. Запишитесь на тест-драйв грузовика ✅ адреса и телефоны автоцентров ☎️ на сайте АвтоБазар`,
    header: `Автосалоны грузовых автомобилей ${p.t(data.city)}`,
    title_uk: `Автосалони вантажних автомобілів ${p.t(data.city)}. Усі автодилери з продажу вантажівок - Автобазар`,
    description_uk: `Автосалони вантажівок ${p.t(data.city)}. Кращі пропозиції на вантажні автомобілі від автодилерів. Запишіться на тест-драйв вантажівки ✅ адреса і телефони автоцентрів ☎️ на сайті Автобазар`,
    header_uk: `Автосалони вантажних автомобілів ${p.t(data.city)}`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/templates.js